import { AppStore } from '@tom-ui/utils'
import { AxiosResponse } from 'axios'

export const onFulfilled = (appStore: AppStore) => {
  return (response: AxiosResponse<any>) => {
    appStore.decreaseLoadingCounter()

    return response
  }
}

export const onRejected = (appStore: AppStore) => {
  return (error: any) => {
    appStore.decreaseLoadingCounter()
    if (error?.response?.status !== 500 && !error?.response?.data?.errors) {
      appStore.setShowAlert(
        'error',
        error?.response?.data?.detail ?? JSON.stringify(error?.message),
      )
    } else if (error?.response?.status === 500) {
      appStore.setShowAlert('error', 'Something went wrong')
    }

    return Promise.reject(error)
  }
}
